// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color, layoutContainer, xScreen } from "@pacific/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

export interface CategoriesPageTitleStyles {
    wrapper?: InjectableCss;
    container?: InjectableCss;
    title?: TypographyPresentationProps;
}

export const categoriesPageTitleStyles: CategoriesPageTitleStyles = {
    wrapper: {
        css: css`
            background-color: ${color("common.ui2")};
            padding: 16px 0;
        `,
    },
    container: {
        css: css`
            ${layoutContainer}
            nav[data-test-selector="pageBreadcrumbs"] {
                margin-bottom: 20px;
                width: 100%;
            }
        `,
    },
    title: {
        variant: "h1",
        css: css`
            margin-bottom: 16px;
        `,
    },
};

export const CategoriesPageTitle = () => {
    const styles = categoriesPageTitleStyles;
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.container}>
                <PageBreadcrumbs />
                <Typography {...styles.title}>{translate("All Products")}</Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: CategoriesPageTitle,
    definition: {
        group: "Categories",
        allowedContexts: ["CategoryListPage"],
    },
};
export default widgetModule;